/*
  * Определяет, находится ли элемент переданный в качестве аргумента, во вьюпорте.
  *
  * @param el - элемент, видимость которого нужно определить
  * @returns - возвращает true, если элемент во вьюпорте, и false, если элемент вне вьюпорта.
*/

export default function isInsideViewport(el: HTMLElement): boolean {
  if (!el)
    return false

  const rect = el.getBoundingClientRect()

  return (
    rect.top >= window.innerHeight
    || rect.bottom <= 0
    || rect.left >= window.innerWidth
    || rect.right <= 0
  )
}
